import { SVGIconComponent } from './types';

export const StatusWarning: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="timeline/status-warning" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="np_warning_1145829_000000" transform="translate(2, 3)" fill="currentColor" fillRule="nonzero">
        <path
          d="M19.6953806,14.5675503 L15.8359836,7.85437705 L11.9739187,1.14298929 C11.5666133,0.435046126 10.8136318,0 9.999888,0 C9.18614419,0 8.43316271,0.435046126 8.02585726,1.14298929 L4.16379237,7.85437705 L0.304395414,14.5675503 C-0.102042951,15.2754935 -0.10117587,16.1473267 0.305263828,16.8552698 C0.712569273,17.563213 1.46466145,17.9991296 2.27842749,18 L17.7215735,18 C18.5353396,17.9991282 19.2874317,17.563213 19.6947372,16.8552698 C20.1011755,16.1473267 20.1020426,15.2754935 19.6956056,14.5675503 L19.6953806,14.5675503 Z M10.7248784,14.8020806 L9.27454192,14.8020806 L9.27454192,13.3469795 L10.7240113,13.3469795 L10.7248784,14.8020806 Z M11.2581105,7.42111646 L10.7153182,12.5833275 L9.28407981,12.5833275 L8.7412875,7.42111646 L8.7412875,6.33653655 L11.2580439,6.33653655 L11.2581105,7.42111646 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </svg>
);
